export const getFeatures = () => window?.AFP_CONFIG?.features || {};

export const SUBJECTS = {
  StandardItem: 'StandardItem',
  EquipmentCodes: 'EquipmentCodes',
  CatalogCodes: 'CatalogCodes',
  FVS: 'FederalVehicleStandards',
  Requirements: 'Requirements',
  PSOQuestionnaire: 'PSOQuestionnaire',
  FVSComments: 'FVSComments',
  Solicitation: 'Solicitation',
  All: 'all',
  Bid: 'Bid',
  BidReport: 'BidReport',
  AllBidReports: 'AllBidReports',
  VehicleGroupEngPOCs: 'VehicleGroupEngPOCs',
  VehicleGroupCoPOCs: 'VehicleGroupCoPOCs',
  Contract: 'Contract',
  ContractReport: 'ContractReport',
  PreBidReport: 'PreBidReport',
  makeModel: 'MakeModel',
  makeModelApproval: 'MakeModelApproval',
};

export const OPERATIONS = {
  View: 'view',
  Review: 'review',
  EngineerReview: 'engineerReview',
  Create: 'create',
  Update: 'update',
  Delete: 'delete',
  Approve: 'approve',
  Manage: 'manage',
  VendorUpdate: 'VendorUpdate',
  OrderAdminUpdate: 'OrderAdminUpdate',
  Support: 'support',
};

export const FVS_STATUS = {
  PeerReview: 'PeerReview',
  PSOCommentOpen: 'PsoCommentOpen',
  PublicCommentOpen: 'PublicCommentOpen',
  AllCommentOpen: 'AllCommentOpen',
  AllCommentClosed: 'AllCommentClosed',
  CommentOpen: 'CommentOpen',
  Published: 'Published',
  Draft: 'Draft',
  Amended: 'Amended',
};

// AFP-229609 PR 2 - commenting state is held per audience on the standard, so
// the two audiences can be in different states at once (e.g. Vehicle Supplier
// closed while Public is still scheduled).
export const FVS_COMMENT_STATUS = {
  Scheduled: 'Scheduled',
  Open: 'Open',
  Closed: 'Closed',
};

// Serialized names of FvsCommentingPeriodUserType. PSO and VehicleSupplier share
// the value 0 for historical reasons and the API serializes it as
// 'VehicleSupplier'.
export const FVS_COMMENT_AUDIENCE = {
  VehicleSupplier: 'VehicleSupplier',
  Public: 'Public',
};

// AFP-229609 - aggregated peer review task status, returned by
// FvsModel.reviewStatus. Separate from FVS_STATUS: a review in flight no longer
// changes the standard's status or who can see it.
export const FVS_REVIEW_STATUS = {
  NotApplicable: 'NotApplicable',
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  Done: 'Done',
};

export const FEATURE_NAMES = {
  STANDARD_ITEM: 'STANDARD_ITEM',
  EQUIPMENT_CODE: 'EQUIPMENT_CODE',
  CATALOG_CODE: 'CATALOG_CODE',
  FEDERAL_VEHICLE_STANDARD: 'FEDERAL_VEHICLE_STANDARD',
};

export const LOCALSTORAGE_KEYS = [
  {
    key: 'STANDARD_ITEM_FILTER',
  },
  {
    key: 'EQUIPMENT_CODES_FILTER',
  },
  {
    key: 'CATALOG_CODES_FILTER',
  },
  {
    key: 'SOLICITATION_TABLE_FILTERS',
  },
];

export const enDashUnicode = '\u2013';
export const emDashUnicode = '\u2014';
export const emSpaceUnicode = '\u0020';
export const CUSTOM_ERROR = 'CUSTOM_ERROR';

export const MAX_ATTACHMENT_SIZE_25 = 25 * 1024 * 1024; // 25 MB
export const MAX_ATTACHMENT_SIZE_50 = 50 * 1024 * 1024; // 50 MB
export const MAX_ATTACHMENT_SIZE_100 = 100 * 1024 * 1024; // 100 MB
export const MAX_ATTACHMENT_SIZE_150 = 150 * 1024 * 1024; // 150 MB
export const MAX_ATTACHMENT_SIZE_200 = 200 * 1024 * 1024; // 200 MB

export const UPLOAD_FILE_TYPES = {
  fvsSupportingDoc: ['pdf', 'jpeg', 'jpg', 'docx', 'csv', 'xls', 'xlsx'],
};
